import { useState } from "react";

function useCounter(
  initialValue: number = 0,
  options?: Partial<{
    min: number;
    max: number;
  }>,
) {
  const [currentValue, setCurrentValue] = useState(initialValue);

  const increment = () => {
    setCurrentValue((v) => {
      if (options?.max !== undefined && v >= options.max) return v;
      return v + 1;
    });
  };

  const decrement = () => {
    setCurrentValue((v) => {
      if (options?.min !== undefined && v <= options.min) return v;
      return v - 1;
    });
  };

  return [currentValue, { increment, decrement }] as const;
}

export default useCounter;
